import script from "./GroupModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupModal.vue?vue&type=script&setup=true&lang=ts"

import "./GroupModal.vue?vue&type=style&index=0&id=0d67f491&scoped=true&lang=scss"

import exportComponent from "E:\\work\\EEEEE\\okpay\\ipay-imi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d67f491"]])

export default __exports__